import { getBrandAndHotelData } from '../../../helpers/handleBrandAndHotelData';
import { ClearAllIndexedDB } from '../../../indexed';
import { authMeRes } from '../../../requests/notifications';
import { clear, getItem, removeItem, setItem } from '../../../utils/localStorage';

export const AuthMeRes = async () => {
    const userData  =  getItem('user');
    const allHotels = getBrandAndHotelData();
    await authMeRes().then((res: any) => {
      // tslint:disable-next-line:no-shadowed-variable
      // tslint:disable-next-line:max-line-length
      const prevHotels = allHotels;
      // tslint:disable-next-line:max-line-length
      const newHotels = res.data && res.data.user && res.data.user.brands && res.data.user.brands.length && res.data.user.brands.flatMap(brand => brand.hotels);
      if ( newHotels && (prevHotels.length !== newHotels.length) ) {
        if (newHotels.length) {
          setItem('selectedHotel', newHotels[0].id);
          setItem('selectedClient', newHotels[0].clientId);
          setItem('allHotels', res.data.user.brands.flatMap(brand => brand.hotels));
        } else {
          removeItem('selectedHotel');
        }
        window.location.reload();
      }
      setItem('user', res.data);
      if (res.data && res.data.userProfile) {
      setItem('userProfile', res.data.userProfile);
      }
    }).catch((err) => {
      // Only a genuine auth/session rejection (401/403, or 409 = session superseded by a
      // newer login) should end the session. A transient network failure - common on iOS
      // WKWebView for the first XHR after the full-page post-login redirect - leaves
      // err.response undefined, so status is falsy and we return early: keep the session and
      // let a later mount retry, rather than bouncing to /login and creating the iOS login loop.
      const status = err && err.response && err.response.status;
      if (status !== 401 && status !== 403 && status !== 409) {
        return;
      }

      ClearAllIndexedDB();
      const isUserIgnoredPin = getItem('isUserIgnoredPin');
      const userProfile = getItem('userProfile');
      const sessionId = getItem('sessionId');
      const selectedHotelId = getItem('selectedHotel');
      const selectedClientId = getItem('selectedClient');
      const iosApp = getItem('iosApp');
      clear();
      let userEmail = '';

      if (userData && userData.user && userData.user.userEmail) {
        userEmail = userData.user.userEmail.trim().toLowerCase();
      } else if (userProfile && userProfile.userEmail) {
        userEmail = userProfile.userEmail.trim().toLowerCase();
      }

      if (userEmail) {
        localStorage.setItem('email', userEmail);
      }
      if (userData && userData.user && userData.user.userPhone) {
        localStorage.setItem('phonenumber', userData.user.userPhone);
      }
      // Use setItem (not raw localStorage) so the value stays readable by getItem.
      setItem('sessionId', sessionId);
      localStorage.setItem('selectedHotel', selectedHotelId);
      localStorage.setItem('selectedClient', selectedClientId);
      setItem('isUserIgnoredPin', isUserIgnoredPin);
      // Preserve the iOS-app context across the forced re-login, since clear() wiped it.
      if (iosApp) {
        setItem('iosApp', iosApp);
      }
      window.location.href = '/login';
  });
  };
